import { Component, computed, input, output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { CardUIType, PlaylistCardShort } from '@app/app/shared/models';
import { Tick01Icon } from '@hugeicons/core-free-icons/index';

@Component({
  selector: 'ptl-card-item-snake-view',
  templateUrl: './card-item-snake-view.component.html',
  styleUrls: ['./card-item-snake-view.component.scss'],
})
export class CardItemSnakeViewComponent {
  card = input<PlaylistCardShort>();
  cardIndex = input(0);
  cardType = input<CardUIType>('general');
  showImage = input(true);
  showMeta = input(true);
  showReviews = input(true);

  cardClick = output<PlaylistCardShort>();
  protected readonly Tick01Icon = Tick01Icon;

  cardSubheader = computed(() => {
    const card = this.card();
    return card?.subHeader ? LanguageCodeHelper.getDataByLanguageCode(card.subHeader).value.trim() : '';
  });
}
